<!--工单聊天记录地图定位-->
<template>
	<div :id="'chatMap'+index" style="width: 400px;height: 180px;"></div>
</template>

<script>
	export default {
		components: {},
		props: {
			index: {
				type: Number
			},
			point: {
				type: String
			},
		},
		data() {
			return {}
		},
		created() {},
		mounted() {
			this.initMap()
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			initMap() {
				var map = new BMap.Map('chatMap'+this.index)
				var point = new BMap.Point(116.331398,39.897445)
				map.centerAndZoom(point,12)
				
				var pointInfo = JSON.parse(this.point)
				var point = new BMap.Point(pointInfo.lng, pointInfo.lat)
				map.centerAndZoom(point, 12)
				var marker = new BMap.Marker(point)
				map.addOverlay(marker)
				marker.setAnimation(BMAP_ANIMATION_BOUNCE)
			},
		}
	}
</script>

<style scoped>

</style>
